export enum EStoreIconType {
	GOOGLE_PLAY,
	APP_STORE,
	HUAWEI_APP_GALLERY
}
